import {
  CANVAS_HIDDEN_FE_TYPES,
  FE_TYPE_TO_BACKEND,
  isFeNodeType,
} from '../generated/nodeDataTypes'

/** Match the canvas rebuild filter before reading or attaching a node. */
export function isRenderableCanvasNodeType(
  feType: string,
  knownNodeTypes?: ReadonlySet<string>,
): boolean {
  return (
    !CANVAS_HIDDEN_FE_TYPES.has(feType) &&
    (!knownNodeTypes || knownNodeTypes.has(feType)) &&
    isFeNodeType(feType)
  )
}

/** Return the backend type only for nodes represented by generated schemas. */
export function schemaBackendType(feType: string): string | undefined {
  if (!Object.prototype.hasOwnProperty.call(FE_TYPE_TO_BACKEND, feType)) return undefined
  return FE_TYPE_TO_BACKEND[feType]
}

/** Convert a schema-supported frontend node type to its backend type. */
export function toBackendType(feType: string): string {
  const backendType = schemaBackendType(feType)
  if (backendType == null) {
    throw new Error(`Unsupported frontend node type: ${feType}`)
  }
  return backendType
}
